import React from 'react';
import { StyleSheet, Document, Text, Page, Font } from '@react-pdf/renderer';
import Header from '../Components/Header';
// import AssessmentSummary from './AssessmentSummary'
import Assessments from './Assessments';
import Developments from './Developments';
import { primaryColorDark } from '../Components/PDFStyles';
import black from '../Fonts/RedHatDisplay-Black.ttf';
import bold from '../Fonts/RedHatDisplay-Bold.ttf';
import medium from '../Fonts/RedHatDisplay-Medium.ttf';
import regular from '../Fonts/RedHatDisplay-Regular.ttf';

const styles = StyleSheet.create({
  pageNumber: {
    position: 'absolute',
    fontSize: 14,
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: primaryColorDark,
    fontWeight: 700,
  },
  page: {
    paddingTop: 80,
    paddingBottom: 55,
    paddingHorizontal: 5,
  },
});

export const ClareMedicaPDF = ({
  identifier,
  developments,
  summary,
  assessments,
  debug = false,
}: {
  identifier?: any;
  developments?: any;
  summary?: any;
  assessments?: any;
  debug?: boolean;
}) => {
  return (
    <Document>
      <Page style={styles.page} wrap>
        <Header
          identifier={identifier}
          debug={debug}
          title={'Patient-Reported Clinical Developments'}
        />
        <Developments developments={developments} />
        <Text
          style={styles.pageNumber}
          render={({ pageNumber }) => `${pageNumber}`}
          fixed
        />
      </Page>
      {/* <Page style={styles.page} wrap>
             <Header
               identifier={identifier}
               debug={debug}
               title={'Patient Summary'}
             />
             <AssessmentSummary summary={summary} />
             <Text
               style={styles.pageNumber}
               render={({pageNumber}) => `${pageNumber}`}
               fixed
             />
           </Page> */}
      <Page style={styles.page} wrap>
        <Header
          identifier={identifier}
          debug={debug}
          title={'Chronic Condition Questionnaires'}
        />
        <Assessments assessments={assessments} />
        <Text
          style={styles.pageNumber}
          render={({ pageNumber }) => `${pageNumber}`}
          fixed
        />
      </Page>
    </Document>
  );
};

// some ttf fonts: https://gist.github.com/sadikay/d5457c52e7fb2347077f5b0fe5ba9300
// only ttf supported at time of writing
Font.register({
  family: 'Red Hat Display',
  fonts: [
    {
      src: black,
      fontStyle: 'normal',
      fontWeight: 900,
    },
    {
      fontStyle: 'normal',
      fontWeight: 700,
      src: bold,
    },
    {
      src: medium,
      fontWeight: 500,
      fontStyle: 'normal',
    },
    {
      fontStyle: 'normal',
      fontWeight: 400,
      src: regular,
    },
  ],
});

export default ClareMedicaPDF;
